export const getFractionDigits = (minimumFractionDigits, maximumFractionDigits) => {
    const minimumIsGreaterThanMaximum = maximumFractionDigits < minimumFractionDigits;
    const safeMaximumFractionDigits = minimumIsGreaterThanMaximum
        ? minimumFractionDigits
        : maximumFractionDigits;
    return {
        minimumFractionDigits,
        maximumFractionDigits: safeMaximumFractionDigits,
    };
};
